module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('site-header'), _vm._v(" "), _c('div', {
    class: _vm.$style.gridContainer
  }, [_c('div', {
    class: [_vm.$style.col, _vm.$style.oneCol],
    staticStyle: {
      "display": "none"
    }
  }, [_c('h2', {
    class: _vm.$style.title
  }, [_vm._v("Vinningar")]), _vm._v(" "), _c('p', {
    class: _vm.$style.text
  }, [_c('carousel', {
    attrs: {
      "perPage": 1,
      "autoplay": true
    }
  }, [_c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": require("./assets/wow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: [_vm.$style.sliderText, _vm.$style.prizeText]
  }, [_c('strong', [_vm._v("WOW air")]), _vm._v(" - Flug fyrir tvo til Evrópu\n              ")])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": require("./assets/bluelagoon.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: [_vm.$style.sliderText, _vm.$style.prizeText]
  }, [_c('strong', [_vm._v("Bláa Lónið")]), _vm._v(" fyrir tvo og út að borða á "), _c('strong', [_vm._v("Lava Restaurant")])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    class: [_vm.$style.col, _vm.$style.twoCol]
  }, [_c('h2', {
    class: _vm.$style.title
  }, [_vm._v("Myndaleikur")]), _vm._v(" "), _c('h3', {
    class: [_vm.$style.title, _vm.$style.titleSmall]
  }, [_vm._v("Ef þú tekur ekki mynd, þá gerðist það ekki!")]), _vm._v(" "), _c('p', {
    class: _vm.$style.text
  }, [_vm._v("\n\n        Á fimmta hundrað myndir bárust í myndaleikinn Við höfum góða sögu að segja sem fram fór í sumar.\n        Þátttakendur þurftu að smella myndum af á Reykjanesi og birta á samfélagsmiðlum undir myllumerkinu #godarsogur.\n        Glæsilegir vinningar voru í boði en trompvinningurinn var flugferð fyrir tvo til Evrópu með WOW.\n\n      ")]), _vm._v(" "), _c('p', {
    class: _vm.$style.text
  }, [_vm._v("\n\n        Jón Óskar Hauksson, formaður Ljósops – áhugaljósmyndarafélags Suðurnesja, fékk trompvinningin fyrir fimm frábærar myndir af Reykjanesi.\n        Lista yfir vinningshafa má sjá hér að neðan en þeir geta nálgast vinningana í Hljómahöllinni í Reykjanesbæ.\n\n      ")]), _vm._v(" "), _c('p', {
    class: _vm.$style.text
  }, [_vm._v("\n\n        Við þökkum kærlega fyrir þátttökuna.\n\n      ")])]), _vm._v(" "), _c('div', {
    class: [_vm.$style.col, _vm.$style.oneCol]
  }, [_c('h2', {
    class: _vm.$style.title
  }, [_vm._v("Vissir þú að...")]), _vm._v(" "), _c('p', {
    class: _vm.$style.text
  }, [_c('carousel', {
    attrs: {
      "perPage": 1,
      "autoplay": true
    }
  }, [_c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": require("./assets/slider1.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Útilegumannabyggð, hellir og minjar af skjóli úr steinum og steyptum veggjum, , fannst við gamla gönguleið nálægt Eldvörpum þegar Hitaveita Suðurnesja var að bora þar árið 1982? "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": require("./assets/slider2.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Aðeins 8 sjómílur suður af Reykjanesi er þverhnípta klettaeyjan Eldey? Eitt skerjanna í klasanum er svokallað Geirfuglasker en þar hélt geirfuglinn síðast til. Eldey er einnig stærsta súlubyggð í heiminum! "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": require("./assets/slider3.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Suður í Krýsuvík er þyrping sprengigíga og einn sá þekktasti er í raun lítið stöðuvatn sem ber heitið Grænavatn? Gígurinn er yfir 6000 ára gamall og vatnið er farið að mygla. Grín! Græni liturinn er kominn til vegna samblöndunar brennisteinstegunda. "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": require("./assets/slider4.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Sogin eru 150 til 200 metra djúp vatnssorfin leirgil og hryggir?  Mikill hiti frá háhitahverum á svæðinu útskýrir litadýrðina sem einkennir þetta sérkennilega háhitasvæði sunnan Trölladyngju og Grænudyngju, skammt frá Keili. "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": require("./assets/slider5.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Brennisteinsfjöll eru stór þyrping móbergsfjalla frá síðari hluta ísaldar? Í norðanverðum Brennisteinsfjöllum er háhitasvæði og í kringum 1880 voru þar brennisteinsnámur sem enn má koma auga á. "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": require("./assets/slider6.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Þetta er Brimketill. Hann er staðsettur rétt hjá Grindavík. Hann varð til vegna stöðugs núnings brims við hraunkatlana. Sundgarpar eiga það til að baða sig í honum, rétt eins og Oddný Nátttröll. Hún var þarna. Hefur þú prófað? "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])]), _vm._v(" "), _c('slide', {
    class: _vm.$style.slide
  }, [_c('img', {
    attrs: {
      "src": require("./assets/slider7.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.sliderText
  }, [_vm._v("\n                Rétt austan við Reykjanesvita er stórbrotið jarðhitasvæði? Þar er Gunnuhver, sem dregur nafn sitt af Guðrúnu nokkurri sem gekk aftur og olli miklum usla á svæðinu. Presturinn Eiríkur Magnússon kom draugsa fyrir kattarnef er hann sendi hann í einn hveranna. Langar þig að hitta Gunnu? "), _c('strong', {
    class: _vm.$style.tag
  }, [_vm._v("#goðarsogur")])])])], 1)], 1)])]), _vm._v(" "), _c('h2', {
    class: [_vm.$style.title, _vm.$style.titleLarge]
  }, [_vm._v("Vinningsmyndir")]), _vm._v(" "), _c('winners')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16d302ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 28
// module chunks = 0